import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Hero = ({ title, description, videoSrc }) => {
    const { t } = useTranslation(); 

    const handleSmoothScroll = (event) => {
        event.preventDefault(); 
        const targetElement = document.querySelector("#about-us");
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY; 
            const offsetPosition = elementPosition - 120; 
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth", 
            });
        }
    };

    return (
        <div className="">
            <div className="relative w-full h-[100vh] overflow-hidden">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute top-0 right-0 object-cover w-full h-full"
                >
                    <source src={videoSrc} type="video/mp4" />
                </video>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        background:
                            "linear-gradient(90deg, rgba(16,16,16) 0%, rgba(0, 0, 0) 25%, rgba(0, 0, 0, 0.0) 100%)",
                    }}
                    className="w-full md:w-4/5"
                ></div>
                <div
                    className="relative w-full flex gap-[32px] h-full text-white max-w-[1290px] px-5 mx-auto items-center"
                    style={{ zIndex: "9" }}
                >
                    <div>
                        <div className="md:w-[80%] w-full">
                            <h1 className="lg:text-[61px] lg:leading-[72px] font-bold md:text-[39px] md:leading-[50px] text-[44.25px] leading-[45px] text-left">
                                {t('hero.title')} 
                            </h1>
                            <p className="mt-4 text-[22px] font-normal leading-[24px] md:w-[80%] w-full">
                                {t('hero.description')} 
                            </p>
                        </div>
                        <div className="flex gap-3 mt-8 md:gap-6">
                            <Link
                                to="/contactus"
                                className="flex items-center justify-center gap-2 p-[10px_24px] rounded-[12px] bg-[#F67E20] text-[#FEEED6] hover:bg-[#FEEED6] hover:text-[#F67E20] font-medium transition-all duration-300 ease-in-out"
                            >
                                {t("nav.contact")} <i className="fa-solid fa-paper-plane"></i>
                            </Link>
                            <a
                                href="#about-us"
                                className="flex items-center justify-center gap-2 p-[10px_24px] rounded-[12px] bg-[#FEEED6] text-[#F67E20] hover:bg-[#F67E20] hover:text-[#FEEED6] font-medium transition-all duration-300 ease-in-out"
                                onClick={handleSmoothScroll} 
                            >
                                {t("hero.learnMore")} <i className="fas fa-arrow-right ml-2"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
